import axiosInstance from '../common/axiosInstance'
import { API_ROUTES } from '../common/routes'

export const postGiveHeartItem = async (payload) => {
  try {
    const res = await axiosInstance.post(API_ROUTES.Live.GiveHeartItem, payload)
    return res.data
  } catch (error) {
    console.error(error)
    return {}
  }
}
